export const ContactSchema = {
  type: "object",
  properties: {
    contactType: { type: "string" },
    firstName: { type: "string" },
    lastName: { type: "string" },
    mail: { type: "string", format: "email" },

    phone: { type: "string" },
  },
  required: ["contactType", "firstName", "lastName"],
  anyOf: [
    { "required": ["mail"] },
    { "required": ["phone"] }
  ]
};

export const ContactSchemaWithEmailRequired = {
  type:"object",
  properties: ContactSchema.properties,
  required: ["contactType", "firstName", "lastName", "email"],
}